import React, { useEffect, useState , useContext} from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../../Shared/AssociateNavbar/Navbar';
import axios from 'axios';
import baseURL from './../../../Apiurs/Apiurls';
import ReusableTable from '../../../Layout/ReusableTable';
import './Quotation.css';
import './../../../Layout/Collapse/Collapse.css';
import { FaHistory } from 'react-icons/fa';
import { AuthContext } from '../../../AuthContext/Authcontext';

const Quotationpage = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [quotations, setQuotations] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();


  const { authToken, userId, userRole } = useContext(AuthContext);

useEffect(() => {
  const fetchQuotations = async () => {
    try {
      const res = await axios.get(`${baseURL}/api/user-quotations/${userId}/${userRole}`);
      
      if (res.data.success) {
        setQuotations(res.data.data);
        setFilteredData(res.data.data); // for ReusableTable or filtering
      } else {
        console.error("API returned failure:", res.data.message);
      }
    } catch (err) {
      console.error("Failed to fetch quotations:", err);
    }
  };

  if (userId) {
    fetchQuotations();
  } else {
    console.warn("User ID not found. Cannot fetch quotations.");
  }
}, [userId]);
  // Columns for ReusableTable
  const columns = [
    { 
      key: 'lead_id', 
      title: 'Lead ID', 
      render: (row) => `Lead${String(row.lead_id).padStart(4, '0')}` 
    },
    { 
      key: 'quotation_number', 
      title: 'Quotation Number', 
      render: (row) => (
        <span
          className="text-primary cursor-pointer "
          style={{ cursor: 'pointer' }}
          onClick={() => navigate(`/s-previewquotation/${row.lead_id}`)}
        >
          {row.quotation_number}
        </span>
      )
    },
{
  key: 'created_at',
  title: 'Quotation Date',
  render: (row) => {
    if (!row.created_at) return '-';
    const date = new Date(row.created_at);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  },
}  ,
  { key: 'subtotal', title: 'Sub Total', render: (row) => row.subtotal },
    { key: 'gst', title: 'GST', render: (row) => row.gst },
    { key: 'total_amount', title: 'Total Amount', render: (row) => row.total_amount },
    {
      key: 'action',
      title: 'Action',  
      render: (row) => (
      


                    <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => navigate(`/s-opp-view-sent-quotations/${row.lead_id}`, )}
            title="History"
          >
            <FaHistory />
          </button>
        
      ),
    },
  ];

  return (
    <div className="CollapseContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Collapse ${collapsed ? 'collapsed' : ''}`}>
        <div className="table-container p-3">
          <ReusableTable
            data={filteredData}
            columns={columns}
            initialEntriesPerPage={5}
            searchPlaceholder="Search leads..."
          />
        </div>
      </div>
    </div>
  );
};

export default Quotationpage;